import React from "react";

const Media = ({width=22, height=20}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 12L21 12M7 19H15M5.8 16H16.2C17.8802 16 18.7202 16 19.362 15.673C19.9265 15.3854 20.3854 14.9265 20.673 14.362C21 13.7202 21 12.8802 21 11.2V5.8C21 4.11984 21 3.27976 20.673 2.63803C20.3854 2.07354 19.9265 1.6146 19.362 1.32698C18.7202 1 17.8802 1 16.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V11.2C1 12.8802 1 13.7202 1.32698 14.362C1.6146 14.9265 2.07354 15.3854 2.63803 15.673C3.27976 16 4.11984 16 5.8 16Z"
                stroke="#2A2E44"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Media;
